import React from "react";
import PropTypes from "prop-types";
import { DownloadIcon } from "../podcast-player/icons";

function DownloadButton({ href }) {
  return (
    <a href={href} download style={{ lineHeight: 0 }}>
      <DownloadIcon fill="#e3e2e2" width={18} />
    </a>
  );
}

DownloadButton.propTypes = {
  href: PropTypes.string
};

export default DownloadButton;
